import React, { useState, useRef } from "react";

import { useObjectStore } from "../zustand/objects";
import { Input, Text } from "@mantine/core";
import { CHROME_TEXT_SIZE } from "../utils/uiChromeTokens";

/** Long titles cap here (ellipsis). Edit field uses measured width up to this. */
const TITLE_MAX_PX = 220;
/** Minimum input width so short names are still comfortable to edit */
const TITLE_EDIT_MIN_PX = 112;
/** Extra px when sizing edit field from measured label (caret / padding) */
const TITLE_EDIT_PAD_PX = 20;

const ProjectName = ({ textColor = "#101828" }) => {
  const { projectName, updateProjectName } = useObjectStore();

  const [editing, setEditing] = useState(false);
  const [editSlotPx, setEditSlotPx] = useState(TITLE_MAX_PX);
  const textMeasureRef = useRef(null);

  const handleClick = () => {
    const el = textMeasureRef.current;
    const measured = el ? el.getBoundingClientRect().width : TITLE_EDIT_MIN_PX;
    const next = Math.min(
      TITLE_MAX_PX,
      Math.max(TITLE_EDIT_MIN_PX, Math.ceil(measured) + TITLE_EDIT_PAD_PX)
    );
    setEditSlotPx(next);
    setEditing(true);
  };

  const handleSubmit = (val) => {
    updateProjectName(val);
    setEditing(false);
  };

  const editSlotStyle = {
    width: editSlotPx,
    minWidth: editSlotPx,
    maxWidth: TITLE_MAX_PX,
    flexShrink: 0,
    overflow: "hidden",
    boxSizing: "border-box",
  };

  return (
    <>
      {editing ? (
        <div style={editSlotStyle}>
          <Input
            size="xs"
            defaultValue={projectName}
            autoFocus
            styles={{
              root: { width: "100%", maxWidth: "100%" },
              wrapper: { width: "100%", maxWidth: "100%" },
              input: { width: "100%", minWidth: 0, maxWidth: "100%" },
            }}
            onBlur={(e) => handleSubmit(e.currentTarget.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit(e.currentTarget.value);
              }
            }}
          />
        </div>
      ) : (
        <div
          ref={textMeasureRef}
          style={{
            maxWidth: TITLE_MAX_PX,
            display: "inline-block",
            verticalAlign: "middle",
            overflow: "hidden",
            flexShrink: 1,
            minWidth: 0,
          }}
        >
          <Text
            size="sm"
            fw={500}
            style={{
              fontSize: CHROME_TEXT_SIZE,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              marginLeft: 0,
              marginRight: 0,
              textOverflow: "ellipsis",
              overflow: "hidden",
              cursor: "pointer",
              color: textColor,
              letterSpacing: "0.02em",
              lineHeight: `${CHROME_TEXT_SIZE + 2}px`,
            }}
            onClick={handleClick}
          >
            {String(projectName ?? "").toUpperCase()}
          </Text>
        </div>
      )}
    </>
  );
};

export default ProjectName;
